export default __webpack_public_path__ + "static/media/Armguards of the Martial Paragon.cb976693.jpg";